export enum INPUT_TYPE {
  BOOLEAN = 'boolean',
  DATE = 'date',
  NUMBER = 'number',
  TEXT = 'text',
  TEXT_LIST = 'text_list',
}

export const OPTIONS: any = [
  {
    value: INPUT_TYPE.BOOLEAN,
    label: 'Boolean'
  },
  /*{
    value: INPUT_TYPE.DATE,
    label: 'Date'
  },*/
  {
    value: INPUT_TYPE.NUMBER,
    label: 'Number',
  },
  {
    value: INPUT_TYPE.TEXT,
    label: 'String',
  },
  {
    value: INPUT_TYPE.TEXT_LIST,
    label: 'List',
  },
];

export interface TextListItem {
  name: string;
  value: string;
}
export const DEFAULT_TEXT_LIST: TextListItem[] = [{"name": "", "value": ""}]
